/* eslint-disable @typescript-eslint/no-unsafe-return -- Recursive key transformation requires flexible return types */
import { ensureArray } from './array'

export const toCamel = (s: string) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}

function isObject(o: unknown): o is Record<string, unknown> {
  return o === Object(o) && !Array.isArray(o) && typeof o !== 'function'
}

export function keysToCamel<T>(o: T, skipKeys?: string[]): T {
  if (isObject(o)) {
    const n: Record<string, unknown> = {}
    Object.keys(o).forEach((k) =>
      ensureArray(skipKeys).includes(k)
        ? (n[toCamel(k)] = o[k])
        : (n[toCamel(k)] = keysToCamel(o[k], skipKeys)),
    )
    return n as T
  } else if (Array.isArray(o)) {
    return o.map((i) => keysToCamel(i, skipKeys)) as T
  }
  return o
}
